import { useRef } from 'react'
import { Button, Dropdown, theme } from 'antd'
import { UploadOutlined, InboxOutlined } from '@ant-design/icons'
import { documentTypeOptions } from '@/data/documentTypes'

interface UploadControlsProps {
  onFileUpload: (files: FileList | null) => void
  onDocumentTypeSelect: (key: string) => void
  onSubmit: () => void
  hasContent: boolean
  isLoading?: boolean
}

export default function UploadControls({ onFileUpload, onDocumentTypeSelect, onSubmit, hasContent, isLoading }: UploadControlsProps) {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const { token } = theme.useToken()

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      gap: 16
    }}>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
          style={{ display: 'none' }}
          onChange={(e) => onFileUpload(e.target.files)}
        />
        <Button 
          icon={<UploadOutlined />}
          onClick={() => fileInputRef.current?.click()}
          style={{ 
            border: `1px solid ${token.colorBorder}`,
            borderRadius: 8,
            height: 32,
            paddingLeft: 12,
            paddingRight: 12,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 13
          }}
        >
          Files
        </Button>
        <Dropdown
          menu={{
            items: documentTypeOptions.map(option => ({
              key: option.key,
              label: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span>{option.icon}</span>
                  <span>{option.label}</span>
                </div>
              ),
              onClick: () => onDocumentTypeSelect(option.key)
            }))
          }}
          trigger={['click']}
        >
          <Button 
            style={{ 
              border: `1px solid ${token.colorBorder}`,
              borderRadius: 8,
              height: 32,
              paddingLeft: 12,
              paddingRight: 12,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              backgroundColor: '#f3e8ff',
              color: '#8b5cf6',
              fontSize: 13
            }}
          >
            📊 Document Types
          </Button>
        </Dropdown>
        <Button 
          icon={<InboxOutlined />}
          style={{ 
            border: 'none',
            borderRadius: 8,
            height: 32,
            width: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: token.colorTextTertiary
          }}
          type="text"
          title="Drag & drop files here"
        />
      </div>
      <Button
        disabled={!hasContent || isLoading}
        loading={isLoading}
        onClick={onSubmit}
        style={{
          borderRadius: 16,
          height: 36,
          paddingLeft: 20,
          paddingRight: 20,
          fontWeight: 500,
          backgroundColor: (!hasContent || isLoading) ? token.colorBgTextHover : '#6b7280',
          borderColor: (!hasContent || isLoading) ? token.colorBorder : '#6b7280',
          color: (!hasContent || isLoading) ? token.colorTextDisabled : 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          fontSize: 14
        }}
      >
        📤 Process & Upload
      </Button>
    </div>
  )
}